import * as classNames from 'classnames';
import { DataService } from '../../services/data_service';
import { Document, Font, pdf } from '@react-pdf/renderer';
import { formatNumber } from '../../core/formatter/formatNumber';
import { IDs } from '../../core/IDs';
import { LastgangDiagramme } from './elemente/LastgangDiagramme';
import { LastgangJahreswerte } from './elemente/LastgangJahreswerte';
import { LastgangPdf } from './pdf/LastgangPdf';
import { LastgangProcess } from './routinen/LastgangProcess';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import style from '../../default.less';
import style2 from './ZusatzTools.less';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormFieldDateTime } from '../../core/forms/WFormFramework';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WSimpleNTupelList } from '../../core/lists/WSimpleNTupelList';
import { WSpinner } from '../../core/elements/spinner/WSpinner';

export interface ZusatztoolsLastgaengeDarstellungProps {
    data: any;
    lastgangSelected: any;
}

export interface ZusatztoolsLastgaengeDarstellungState {
    dataDiagram: any;
    dataPdf: any;
    diagramOptions: any[];
    isLoaded: boolean;
    dataLoaded: any;
    asyncItems: number;
    lastgangData: any;
    showSpinner: boolean;
    stampFrom: number;
    stampMax: number;
    stampMin: number;
    stampTo: number;
    areaFilters: any;
    interval: string;
    intervalFilter: string;
    isArea: boolean;
    curListPageIndex: number;
    offsetScrollbar: number;
    functions: any;
    curValue: string;
    curDiagram: string;
    sortColumn: string;
    sortOrderDesc: boolean;
}

export class ZusatztoolsLastgaengeDarstellung extends
    React.Component<ZusatztoolsLastgaengeDarstellungProps, ZusatztoolsLastgaengeDarstellungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataDiagram: null,
            dataPdf: null,
            diagramOptions: null,
            isLoaded: false,
            dataLoaded: undefined,
            asyncItems: 2,
            lastgangData: undefined,
            showSpinner: false,
            stampFrom: undefined,
            stampMax: undefined,
            stampMin: undefined,
            stampTo: undefined,
            areaFilters: {},
            interval: '12#h',
            intervalFilter: 'none',
            isArea: false,
            curListPageIndex: 0,
            offsetScrollbar: 0,
            functions: {},
            curValue: 'value0',
            curDiagram: undefined,
            sortColumn: 'stamp',
            sortOrderDesc: false
        };
        this.getPdf = this.getPdf.bind(this);
        this.onChangeDateFilter = this.onChangeDateFilter.bind(this);
        this.onChangeDiagram = this.onChangeDiagram.bind(this);
        this.onChangeFunctionColumn = this.onChangeFunctionColumn.bind(this);
        this.onChangeInterval = this.onChangeInterval.bind(this);
        this.onChangeIntervalFilter = this.onChangeIntervalFilter.bind(this);
        this.onChangeListPage = this.onChangeListPage.bind(this);
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.onResetSettings = this.onResetSettings.bind(this);
        this.refList = React.createRef();
        this.setDiagramOptions = this.setDiagramOptions.bind(this);
        Moment.locale('de');
    }

    @lazyInject(DataService) private dataService: DataService;

    private readonly areas: any = {
        'month': { interval: '1#M', reset: 'alle Monate' },
        'week': { interval: '1#w', reset: 'alle Wochen', prefix: 'KW ' },
        'day': { interval: '1#d', reset: 'alle Tage' }
    };
    private colors: string[] = ['#6351bd', '#6b94c7', '#ce8e7e'];
    private columns: any = {};
    private data: any[] = [];
    private dataFiltered: any[] = [];
    private dataDiagramFiltered: any[] = [];
    private dataTable: any[] = [];
    private dataView: any[] = [];
    private readonly functions: any = {
        'avg': { name: 'avg.' },
        'min': { name: 'min.' },
        'max': { name: 'max.' }
    };
    private readonly intervalFilters: any = {
        'none': { name: 'Gesamt', filter: null },
        'no_weekend': { name: 'nur Wochentage', filter: { weekdays: [1, 2, 3, 4, 5] } }
    };
    private readonly intervals: any = {
        '1#h': { name: '1 Stunde' },
        '12#h': { name: '12 Stunden' },
        '1#d': { name: 'Tag' },
        '1#w': { name: 'Woche', prefix: 'KW ' },
        '1#M': { name: 'Monat' },
        '1#Q': { name: 'Quartal' },
        '1#y': { name: 'Jahr' }
    };
    private LastgangTool: any;
    private lineColors: any = {};
    private matchLimit: number = 1000;
    private pages: any[] = [];
    private readonly pageFilters: any = {
        'all': { interval: '1#M' },
        '1#h': { interval: '1#M' }
    };
    private refList: any;
    private tsLoaded: number = null;
    private tsStart: number = null;
    private units: any = {};
    private widthChart: number = 880;
    private widthList: number = 380;

    componentDidMount(): void {
        this.widthChart = (document.documentElement.clientWidth > 1280 ? document.documentElement.clientWidth : 1280) - 72;
        this.setState({ showSpinner: true }, () => this.loadArchiv(this.props.lastgangSelected.datei));
    }

    componentDidUpdate(): void {
        if (this.refList.current !== null) {
            const offset: number = this.refList.current.parentNode.offsetWidth - this.refList.current.clientWidth;

            if (offset !== this.state.offsetScrollbar) {
                this.setState({ offsetScrollbar: offset });
            }
        }
    }

    getAreaFilter(key?: string, value?: number): any {
        const areaFilters: any = this.state.areaFilters || {};
        const days: number[] = ((this.state.lastgangData || {})[this.areas.day.interval] || []).map((data: any) => data.stamp);
        const dayFilter = (value: number) => value >= this.state.stampFrom && value <= this.state.stampTo && days.indexOf(value) !== -1;
        const hasDateFilter: boolean = this.state.stampFrom !== this.state.stampMin || this.state.stampTo !== this.state.stampMax;
        const monthFilter = (value: number) => Moment(value).format('YYYYMM') >= Moment(Moment.unix(this.state.stampFrom / 1000)).format('YYYYMM')
            && Moment(value).format('YYYYMM') <= Moment(Moment.unix(this.state.stampTo / 1000)).format('YYYYMM');
        const weekFilter = (value: number) => Moment(value).isoWeekday(1).format('YYYYWW') >= Moment(Moment.unix(this.state.stampFrom / 1000)).isoWeekday(1).format('YYYYWW')
            && Moment(value).isoWeekday(1).format('YYYYWW') <= Moment(Moment.unix(this.state.stampTo / 1000)).isoWeekday(1).format('YYYYWW');
        const whitelist: any = {};
        const getDate = (key: string, format: string): string => (+(areaFilters[key] || {}).value || 0) > 0
            ? Moment(Moment.unix(areaFilters[key].value / 1000)).format(format) : null;

        if (key) {
            areaFilters[key].value = value;
        }

        if (areaFilters.month.value && !monthFilter(areaFilters.month.value)) {
            areaFilters.month.value = 0;
        }

        if (
            (areaFilters.month.value && areaFilters.week.value
                && (!weekFilter(areaFilters.week.value)
                    || (getDate('week', 'YYYYMM') !== getDate('month', 'YYYYMM')
                        && Moment(Moment.unix(areaFilters.week.value / 1000)).isoWeekday(7).format('YYYYMM') !== getDate('month', 'YYYYMM')
                    )
                )
            )
            || (!areaFilters.month.value && areaFilters.week.value && !weekFilter(areaFilters.week.value))
        ) {
            areaFilters.week.value = 0;
        }

        if (
            (areaFilters.week.value && areaFilters.day.value
                && (!dayFilter(areaFilters.day.value)
                    || (getDate('day', 'YYYYWW') !== getDate('week', 'YYYYWW')
                        && Moment(Moment.unix(areaFilters.day.value / 1000)).isoWeekday(1).format('YYYYWW') !== getDate('week', 'YYYYWW')
                    )
                )
            )
            || (areaFilters.month.value && !areaFilters.week.value && areaFilters.day.value
                && (!dayFilter(areaFilters.day.value) || getDate('day', 'YYYYMM') !== getDate('month', 'YYYYMM'))
            )
            || (!areaFilters.month.value && !areaFilters.week.value && areaFilters.day.value && !dayFilter(areaFilters.day.value))
        ) {
            areaFilters.day.value = 0;
        }

        if (areaFilters.week.value && !areaFilters.month.value) {
            whitelist.day = ((this.state.lastgangData || {})[this.areas.day.interval] || []).filter((data: any) =>
                dayFilter(data.stamp) && Moment(data.datetime).format('YYYYWW') === getDate('week', 'YYYYWW')
            );

            if (hasDateFilter) {
                whitelist.week = ((this.state.lastgangData || {})[this.areas.week.interval] || []).filter((data: any) =>
                    weekFilter(data.datetime)
                );
                whitelist.month = ((this.state.lastgangData || {})[this.areas.month.interval] || []).filter((data: any) =>
                    monthFilter(data.datetime)
                );
            }
        } else if (areaFilters.week.value && areaFilters.month.value) {
            whitelist.day = ((this.state.lastgangData || {})[this.areas.day.interval] || []).filter((data: any) =>
                dayFilter(data.stamp) && Moment(data.datetime).format('YYYYWW') === getDate('week', 'YYYYWW')
            );
            whitelist.week = ((this.state.lastgangData || {})[this.areas.week.interval] || []).filter((data: any) =>
                weekFilter(data.datetime) && (Moment(data.datetime).format('YYYYMM') === getDate('month', 'YYYYMM')
                    || Moment(data.datetime).isoWeekday(7).format('YYYYMM') === getDate('month', 'YYYYMM'))
            );

            if (hasDateFilter) {
                whitelist.month = ((this.state.lastgangData || {})[this.areas.month.interval] || []).filter((data: any) =>
                    monthFilter(data.datetime)
                );
            }
        } else if (areaFilters.month.value) {
            whitelist.day = ((this.state.lastgangData || {})[this.areas.day.interval] || []).filter((data: any) =>
                dayFilter(data.stamp) && Moment(data.datetime).format('YYYYMM') === getDate('month', 'YYYYMM')
            );
            whitelist.week = ((this.state.lastgangData || {})[this.areas.week.interval] || []).filter((data: any) =>
                weekFilter(data.datetime) && (Moment(data.datetime).format('YYYYMM') === getDate('month', 'YYYYMM')
                    || Moment(data.datetime).isoWeekday(7).format('YYYYMM') === getDate('month', 'YYYYMM'))
            );

            if (hasDateFilter) {
                whitelist.month = ((this.state.lastgangData || {})[this.areas.month.interval] || []).filter((data: any) =>
                    monthFilter(data.datetime)
                );
            }
        } else if (hasDateFilter) {
            whitelist.day = ((this.state.lastgangData || {})[this.areas.day.interval] || []).filter((data: any) =>
                dayFilter(data.stamp)
            );
            whitelist.week = ((this.state.lastgangData || {})[this.areas.week.interval] || []).filter((data: any) =>
                weekFilter(data.datetime)
            );
            whitelist.month = ((this.state.lastgangData || {})[this.areas.month.interval] || []).filter((data: any) =>
                monthFilter(data.datetime)
            );
        }

        Object.keys(areaFilters).forEach((key: string) => {
            const areaInterval: string = (this.areas[key].interval || '').toString().split('#')[1] || null;
            const prefix: string = this.areas[key].prefix || null;
            const lastgangData: any = whitelist[key] ? whitelist[key] : (this.state.lastgangData || {})[this.areas[key].interval] || [];
            areaFilters[key].options = [];

            lastgangData.forEach((data: any) => {
                const name: string = areaInterval
                    ? (areaInterval === 'w'
                        ? `${prefix || ''}${Moment(data.datetime).isoWeekday(1).format(this.getIntervalDateFormat(areaInterval))}`
                        : `${prefix || ''}${Moment(data.datetime).format(this.getIntervalDateFormat(areaInterval))}`)
                    : Moment(data.datetime).format(areaInterval);
                areaFilters[key].options.push({ value: data.stamp || null, name })
            });
        });

        return areaFilters;
    }

    getCurDiagramState(): any {
        return this.state.curDiagram
            ? { curDiagram: `${(this.state.curDiagram || '').toString().split('°')[0]}°${Math.floor(Math.random() * 1e12)}` }
            : {};
    }

    getDiagramData(): any {
        const data: any = { legendTitle: [], lineColor: [], lineWidth: [], unit: [], visibleData: [] };
        const setLine = (name: string) => {
            if (!this.lineColors[name]) {
                const color: string = (this.colors || []).shift()
                    || `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
                this.lineColors[name] = color;
            }
            data.lineColor.push(this.lineColors[name]);
            data.lineWidth.push(2);
        };

        Object.keys(this.columns).forEach((key: string) => {
            const unit: string = (this.units[key] || {}).name || null;

            Object.keys(this.state.functions[key] || {}).forEach((key2: string) => {
                if (key !== this.state.curValue) {
                    return;
                }

                if (this.state.functions[key][key2]) {
                    data.legendTitle.push(key2 === 'avg'
                        ? (`${this.columns[key].name || ''}${unit ? ` [${unit}]` : ''}`)
                        : (`${this.columns[key].name || ''} ${this.functions[key2].name || ''}${unit ? ` [${unit}]` : ''}`)
                    );
                    // data.unit.push(unit);
                    data.visibleData.push(key2 === 'avg' ? key : `${key}-${key2}`);
                    setLine(key2 === 'avg' ? key : `${key}-${key2}`);
                }
            });
        });

        if (!(this.units[this.state.curValue] || {}).isPower) {
            data.referenceLines = [];
        }

        return data;
    }

    getExport(): any {
        const dateFormat: string = this.getIntervalDateFormat(undefined, 'export');
        const headers: string[] = [this.getIntervalDateHeader()];
        const columnWidths: number[] = [(headers[0] || '').toString().length];
        const interval: string = this.state.interval || null;
        const sortColumn: string = interval === 'all' && (this.state.sortColumn || '').toString().endsWith('-max')
            ? this.state.sortColumn.substring(0, this.state.sortColumn.length - '-max'.length)
            : this.state.sortColumn || 'stamp';
        const sortOrderDesc: boolean = this.state.sortOrderDesc || false;
        const setMaxWidth = (value: number | string, index: number) => {
            columnWidths[index] = (value || '').toString().length > (columnWidths[index] || 0)
                ? value.toString().length : columnWidths[index] || 1;
        };
        const data: any[] = (this.dataFiltered || [])
            .sort((a: any, b: any) => (+a[sortColumn] || 0) < (+b[sortColumn] || 0)
                ? (sortOrderDesc ? 1 : -1) : (sortOrderDesc ? -1 : 1)
            )
            .map((item: any) => {
                const values: any[] = [];
                const getDate = (): string => {
                    return +item.stamp > 0
                        ? (this.state.interval.split('#')[1] === 'w'
                            ? Moment(item.datetime).isoWeekday(1).format(dateFormat)
                            : Moment(item.datetime).format(dateFormat))
                        : null
                };
                let value: number | string = getDate();
                let i: number = 0;
                values.push(value);
                setMaxWidth(value, i++);

                Object.keys(this.columns).forEach((key: string) => {
                    Object.keys(this.state.functions[key] || {}).forEach((key2: string) => {
                        if (this.state.functions[key][key2]) {
                            value = key2 === 'avg' || interval === 'all'
                                ? (typeof item[key] !== 'undefined' ? +item[key] : null)
                                : (typeof item[`${key}-${key2}`] !== 'undefined' ? +item[`${key}-${key2}`] : null);
                            values.push(value);
                            setMaxWidth(value, i++);
                        }
                    });
                });
                return values;
            });
        let i: number = 0;

        Object.keys(this.columns).forEach((key: string) => {
            const unit: string = (this.units[key] || {}).name || null;

            Object.keys(this.state.functions[key] || {}).forEach((key2: string) => {
                if (this.state.functions[key][key2]) {
                    const value: string = key2 === 'avg'
                        ? (`${this.columns[key].name || ''}${unit ? ` [${unit}]` : ''}`)
                        : (`${this.columns[key].name || ''} ${this.functions[key2].name || ''}${unit ? ` [${unit}]` : ''}`);
                    headers.push(value);
                    setMaxWidth(value, ++i);
                }
            });
        });
        data.unshift(headers);

        return { data, columnWidths };
    }

    getFunctionsState(interval: string): any {
        if (interval !== 'all') {
            return {};
        }
        const functions: any = this.state.functions || {};

        Object.keys(functions || {}).forEach((key: string) => {
            const isPower: boolean = (this.units[key] || {}).isPower || false;

            Object.keys(functions[key] || {}).forEach((key2: string) => {
                functions[key][key2] = key2 === (isPower ? 'max' : 'avg');
            });
        });

        return { functions };
    }

    getIntervalDateFormat(interval?: string, type?: string): string {
        const year: string = type === 'export' ? 'YYYY' : 'YY';
        interval = typeof interval === 'undefined' ? (this.state.interval || '').toString().split('#')[1] : interval;

        switch (interval) {
            case 'd': return 'DD.MM.YYYY';
            case 'h': return `DD.MM.${year} HH:mm`;
            case 'm': return `DD.MM.${year} HH:mm`;
            case 'M': return 'MMM YYYY';
            case 'Q': return 'Q. YYYY';
            case 's': return `DD.MM.${year} HH:mm:ss`;
            case 'w': return 'WW YYYY';
            case 'y': return 'YYYY';
            default: return `DD.MM.${year} HH:mm`;
        }
    }

    getIntervalDateHeader(): string {
        switch (this.state.interval.split('#')[1]) {
            case 'd': return 'Tag';
            case 'M': return 'Monat';
            case 'Q': return 'Quartal';
            case 'w': return 'KW';
            case 'y': return 'Jahr';
            default: return 'Zeitpunkt';
        }
    }

    getIntervalDiagram(): string {
        const areaFilterDay: number = ((this.state.areaFilters || {}).day || {}).value || null;
        const areaFilterDays: any[] = ((this.state.areaFilters || {}).day || {}).options || [];
        const curDays: number = areaFilterDay ? 1 : areaFilterDays.length;
        const maxDays: number = Moment.unix(this.state.stampTo / 1000).diff(Moment.unix(this.state.stampFrom / 1000), 'd') || 1;
        const lastgangData: any = this.state.lastgangData || {};
        const maxValues: number = 1440;

        if (['all', '1#h'].indexOf(this.state.interval) === -1) {
            return this.state.interval;
        }

        if (
            (lastgangData[this.state.interval] || []).length
            && ((lastgangData[this.state.interval].length / maxDays) * curDays) > maxValues
        ) {
            if ((lastgangData['1#h'] || []).length && ((lastgangData['1#h'].length / maxDays) * curDays) > maxValues) {
                return (lastgangData['12#h'] || []).length ? '12#h' : this.state.interval;
            }
            return (lastgangData['1#h'] || []).length ? '1#h' : this.state.interval;
        }
        return this.state.interval;
    }

    getPdf(data: JSX.Element[]): void {
        Font.registerHyphenationCallback((word: any) => word.split(/([+,\-,_,/])/));
        this.processPdf(data);
        this.setState({ dataPdf: null });
    }

    async processPdf(data: JSX.Element | JSX.Element[]): Promise<void> {
        data = <Document>{data}</Document>;
        try {
            const blob = await pdf(data).toBlob();
            const pdfString: string = URL.createObjectURL(blob);
            this.setState({ showSpinner: false });
            const filename: string = (
                'Lastgang ' +
                `[${new Date().toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })}]` +
                '.pdf'
            );
            // const a = document.createElement('a');
            // a.target = '_blank';
            // a.title = filename;
            // a.href = pdfString;
            // a.download = filename;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
            saveAs(pdfString, filename);
        } catch (error) {
            console.log('error: ', error);
            this.setState({ showSpinner: false });
        }
    }

    getSortingState(interval: string): any {
        return interval !== 'all' || this.state.sortColumn === 'stamp' || (this.state.sortColumn || '').toString().endsWith('-max')
            ? {}
            : { sortColumn: 'stamp', sortOrderDesc: false };
    }

    isArea(data?: any): boolean {
        const areaFilters: any = data || this.state.areaFilters || {};

        return !!(
            ((areaFilters || {}).month || {}).value || ((areaFilters || {}).week || {}).value || ((areaFilters || {}).day || {}).value
        );
    }

    loadArchiv(archivId: number): void {
        this.dataService.loadDataForModul(
            IDs.ENT_ARCHIV_ITEMS,
            { tid: archivId },
            { resolve: true, fieldList: 'name, file' },
            'wips',
            (result: any) => {
                // console.log(archivId, result);
                if (result[IDs.ENT_ARCHIV_ITEMS] && result[IDs.ENT_ARCHIV_ITEMS][0]) {
                    let fileName = result[IDs.ENT_ARCHIV_ITEMS][0]['file'];
                    if (fileName.substr(0, 11) === 'wips3_2013/') {
                        fileName = fileName.substr(11);
                    }
                    this.dataService.loadRessource(fileName, 'archiv', (b64: string) => {
                        const dataLoaded = atob(b64);
                        this.onDataLoaded(dataLoaded);
                    });
                } else {
                }
            }
        );
    }

    onChangeAreaFilter(event: any, key: string): void {
        const value: number = +event.target.value;
        const areaFilters: any = this.getAreaFilter(key, value);
        const isArea: boolean = this.isArea(areaFilters) || false;
        const interval: string = isArea
            ? (this.state.isArea ? this.state.interval : 'all')
            : this.state.interval;
        this.setState(
            { areaFilters, interval, isArea, showSpinner: true },
            () => {
                this.setData();
                window.setTimeout(() =>
                    this.setState({
                        ...(this.getCurDiagramState() || {}),
                        curListPageIndex: 0,
                        ...(this.getFunctionsState(interval) || {}),
                        ...(this.getSortingState(interval) || {})
                    })
                );
            }
        );
    }

    onChangeDateFilter(name: string, value: any): void {
        if (['stampFrom', 'stampTo'].indexOf(name) === -1) {
            return;
        }
        value = name === 'stampFrom'
            ? +Moment.unix(value).hour(0).minute(0).second(0)
            : +Moment.unix(value).hour(23).minute(59).second(59);
        this.setState<never>(
            { showSpinner: true, [name]: value },
            () => {
                const areaFilters: any = this.getAreaFilter();
                window.setTimeout(() =>
                    this.setState(
                        {
                            areaFilters,
                            ...(this.getCurDiagramState() || {}),
                            curListPageIndex: 0,
                            isArea: this.isArea(areaFilters) || false
                        },
                        this.setData
                    )
                );
            }
        );
    }

    onChangeDiagram(event: any): void {
        const value: string = event.target.value;
        this.setState(
            { showSpinner: true },
            () => window.setTimeout(() => this.setState({ curDiagram: value }))
        );
    }

    onChangeFunction(event: any, key: string): void {
        const checked: boolean = event.target.checked;
        const functions: any = this.state.functions;
        functions[this.state.curValue][key] = checked;
        this.setState(
            { functions, showSpinner: true },
            () => {
                this.setData();
                window.setTimeout(() =>
                    this.setState<never>({
                        ...((this.state.curDiagram || '').toString().startsWith('interval')
                            ? this.getCurDiagramState() || {}
                            : { showSpinner: false }
                        ),
                        ...(`${this.state.curValue}-${key}` === this.state.sortColumn && !checked
                            ? { sortColumn: 'stamp', sortOrderDesc: false } : {}
                        )
                    })
                );
            }
        );
    }

    onChangeFunctionColumn(event: any): void {
        const isDiagramInterval: boolean = (this.state.curDiagram || '').toString().startsWith('interval');
        const state: any = { curValue: event.target.value };
        this.setState(
            isDiagramInterval ? { showSpinner: true } : state,
            isDiagramInterval ? () => window.setTimeout(() => this.setState({ ...(this.getCurDiagramState() || {}), ...state })) : null
        );
    }

    onChangeInterval(event: any): void {
        const value: string = event.target.value;
        this.setState(
            { curListPageIndex: 0, interval: value, showSpinner: true },
            () => {
                this.setData();
                window.setTimeout(() =>
                    this.setState({
                        ...(this.getCurDiagramState() || {}),
                        curListPageIndex: 0,
                        ...(this.getFunctionsState(value) || {}),
                        ...(this.getSortingState(value) || {})
                    })
                );
            }
        );
    }

    onChangeIntervalFilter(event: any): void {
        const value: string = event.target.value;
        this.setState(
            { showSpinner: true },
            () => window.setTimeout(() =>
                this.setState(
                    {
                        curListPageIndex: 0,
                        intervalFilter: value,
                        lastgangData: this.LastgangTool.getIntervalData((this.intervalFilters[value] || {}).filter || null)
                    },
                    () => {
                        const areaFilters: any = this.getAreaFilter();
                        this.setState({ areaFilters, isArea: this.isArea(areaFilters) || false }, this.setData);
                    }
                )
            )
        );
    }

    onChangeListPage(event: any): void {
        const curListPageIndex: number = event.target.value;
        this.setState(
            { curListPageIndex, showSpinner: true },
            () => window.setTimeout(() => this.setState({ showSpinner: false }))
        );
    }

    onResetSettings(): void {
        const areaFilters: any = this.state.areaFilters || {};
        areaFilters.day.value = 0;
        areaFilters.month.value = 0;
        areaFilters.week.value = 0;
        this.setState(
            {
                areaFilters,
                curValue: 'value0',
                interval: '12#h',
                isArea: false,
                showSpinner: true,
                sortColumn: 'stamp',
                sortOrderDesc: false,
                stampFrom: this.state.stampMin,
                stampTo: this.state.stampMax
            },
            () => window.setTimeout(() =>
                this.setState(
                    {
                        ...(this.getCurDiagramState() || {}),
                        curListPageIndex: 0,
                        intervalFilter: 'none',
                    },
                    () => this.setState({ areaFilters: this.getAreaFilter() }, this.setData)
                )
            )
        );
    }

    render(): JSX.Element {
        if (!this.tsStart) {
            this.tsStart = +new Date();
        } else if (this.tsLoaded) {
            console.log('loading time: ', `${(this.tsLoaded - this.tsStart) / 1000} sec`);
            console.log('processing time: ', `${(+new Date() - this.tsLoaded) / 1000} sec`);
            this.tsLoaded = null;
        }

        if (this.state.isLoaded && (!this.state.stampFrom || !this.state.stampTo)) {
            return (
                <div style={{ fontSize: 12, padding: 16 }}>
                    evtl. fehlerhafte Konfiguration oder Daten...
                </div>
            );
        }

        return (
            <div
                className={style2.Lastgang}
                style={{
                    lineHeight: 1, padding: 20, paddingRight: 0, minWidth: 1280, width: document.documentElement.clientWidth - 12,
                    boxSizing: 'border-box', overflow: 'hidden auto'
                }}
            >
                {this.state.isLoaded && this.renderContent()}
                {this.state.dataPdf &&
                    <LastgangPdf
                        data={this.state.dataPdf}
                        onDone={this.getPdf}
                    />
                }
                {this.state.showSpinner &&
                    <div className={style2.spinner}>
                        <WSpinner />
                    </div>
                }
            </div>
        );
    }

    renderAreaFilter(): JSX.Element {
        return <>
            <div style={{ backgroundColor: '#ddd', padding: 3 }}>Bereich</div>
            <div className={style.rowContainer} style={{ alignItems: 'center' }}>
                {Object.keys(this.state.areaFilters || {}).map((key: string) =>
                    <select
                        key={`area-${key}`}
                        style={{ width: '100%', padding: 1 }}
                        value={this.state.areaFilters[key].value}
                        // disabled={!(this.state.curDiagram || '').toString().startsWith('interval')}
                        onChange={(event: any) => this.onChangeAreaFilter(event, key)}
                    >
                        <option key='area-${key}-' value={0}>
                            {`[${this.areas[key].reset}]`}
                        </option>
                        {(this.state.areaFilters[key].options || []).map((data: any, index: number) =>
                            <option key={`area-${key}-${index}`} value={data.value || null}>
                                {data.name || null}
                            </option>
                        )}
                    </select>
                )}
            </div>
        </>;
    }

    renderColumnSelect(): JSX.Element {
        return <>
            <div style={{ backgroundColor: '#ddd', padding: 3 }}>
                Einheit
            </div>
            <select
                style={{ width: '100%', padding: 1 }}
                value={this.state.curValue}
                disabled={Object.keys(this.state.functions).length === 1}
                onChange={this.onChangeFunctionColumn}
            >
                {Object.keys(this.columns).map((key: string) => {
                    const unit: string = (this.units[key] || {}).name || null;
                    return (
                        <option key={`column-${key}`} value={key}>
                            {`${this.columns[key].name || ''}${unit ? ` [${unit}]` : ''}`}
                        </option>
                    );
                })}
            </select>
        </>;
    }

    renderContent(): JSX.Element {
        return <>
            <div className={style.rowContainer} style={{ textAlign: 'center', marginLeft: -3, alignItems: 'baseline' }}>
                <div style={{ fontSize: 11, width: 120, margin: 0, padding: 3, boxSizing: 'border-box' }}>
                    <div style={{ backgroundColor: '#ddd', padding: 3 }}>vorliegende Daten</div>
                    <div className={style.rowContainer} style={{ padding: 3 }}>
                        <div>{Moment(this.state.stampMin).format('DD.MM.YY')}</div>
                        <span style={{ margin: 'auto 3px' }}>-</span>
                        <div>{Moment(this.state.stampMax).format('DD.MM.YY')}</div>
                    </div>
                </div>
                {this.renderControls()}
            </div>
            <div style={{ marginTop: 15 }}>
                {this.renderDiagram()}
            </div>
            <div className={style.rowContainer} style={{ marginTop: 15 }}>
                {this.renderList()}
                {this.renderJahresdaten()}
            </div>
        </>;
    }

    renderControls(): JSX.Element {
        const styleColumn: React.CSSProperties = { fontSize: 11, margin: 0, padding: 3, boxSizing: 'border-box' };

        return (
            <div className={style.rowContainer}>
                <div style={styleColumn}>{this.renderDateFilter()}</div>
                <div style={styleColumn}>{this.renderColumnSelect()}</div>
                <div style={styleColumn}>{this.renderAreaFilter()}</div>
                <div style={{ ...styleColumn, width: 220 }}>
                    {this.renderIntervalSelect()}
                </div>
                {/*<div style={{ ...styleColumn, width: 120 }}>
                    {this.renderDiagramSelect()}
                </div>*/}
                <div style={{ ...styleColumn, paddingTop: 1 }}>
                    {this.renderResetButton()}
                </div>
                <div style={{ ...styleColumn, paddingTop: 1 }}>
                    {this.renderExportButton()}
                </div>
                <div style={{ ...styleColumn, paddingTop: 1 }}>
                    {this.renderPdfButton()}
                </div>
                <div style={{ ...styleColumn, paddingTop: '1em', paddingLeft: '1em' }}>
                    {this.renderHelpIcon()}
                </div>
            </div>
        );
    }

    renderDateFilter(): JSX.Element {
        return <>
            <div style={{ backgroundColor: '#ddd', padding: 3 }}>Anzeige</div>
            <div className={style.rowContainer} style={{ alignItems: 'center' }}>
                <WFormFieldDateTime
                    label={null}
                    name='stampFrom'
                    value={this.state.stampFrom / 1000}
                    minDate={new Date(this.state.stampMin)}
                    maxDate={new Date(this.state.stampTo)}
                    withTimePicker={false}
                    onValueChange={this.onChangeDateFilter}
                    // disabled={!(this.state.curDiagram || '').toString().startsWith('interval')}
                    required
                    datePickerCustomClass={style2.datePicker}
                    WActionButtonStyleProps={{ width: 20, height: 20 }}
                    hideButtons
                />
                <span style={{ margin: 'auto 3px' }}>-</span>
                <WFormFieldDateTime
                    label={null}
                    name='stampTo'
                    value={this.state.stampTo / 1000}
                    minDate={new Date(this.state.stampFrom)}
                    maxDate={new Date(this.state.stampMax)}
                    withTimePicker={false}
                    onValueChange={this.onChangeDateFilter}
                    // disabled={!(this.state.curDiagram || '').toString().startsWith('interval')}
                    required
                    datePickerCustomClass={style2.datePicker}
                    WActionButtonStyleProps={{ width: 20, height: 20 }}
                    hideButtons
                />
            </div>
        </>;
    }

    renderDiagram(): JSX.Element {
        const intervalFilter: any = (this.intervalFilters[this.state.intervalFilter] || {}).filter || {};

        return (
            <div style={{ fontSize: 12, height: 300 }}>
                <LastgangDiagramme
                    key='interval'
                    containerSize={{ width: this.widthChart, height: 300 }}
                    data={this.state.dataDiagram}
                    filter={intervalFilter}
                    id={this.state.curDiagram}
                    isLoaded={() => {
                        if (!this.state.asyncItems) {
                            this.setState({ showSpinner: false });
                        }
                    }}
                    onDone={this.setDiagramOptions}
                    custom={{ ...(this.getDiagramData() || {}), data: this.dataView || [] }}
                />
            </div>
        );
    }

    renderDiagramSelect(): JSX.Element {
        return <>
            <div style={{ backgroundColor: '#ddd', padding: 3 }}>
                Grafik
            </div>
            <select
                style={{ width: '100%', padding: 1 }}
                value={this.state.curDiagram}
                onChange={this.onChangeDiagram}
            >
                {(this.state.diagramOptions || []).map((option: any, index: number) =>
                    <option key={`diagram-${index}`} value={option.key || null}>
                        {option.name || null}
                    </option>
                )}
            </select>
        </>;
    }

    renderExportButton(): JSX.Element {
        const styleProps: React.CSSProperties = this.state.showSpinner ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {};

        return (
            <WActionButton
                label='Daten exportieren'
                insideText='Daten exportieren'
                key='export'
                action='export'
                disabled={this.state.showSpinner}
                divStyle={{ fontSize: 12, textAlign: 'left', whiteSpace: 'nowrap' }}
                styleProps={styleProps}
                onAction={() => {
                    const lastgang: any = this.getExport() || {};
                    const columnWidths: number[] = lastgang.columnWidths || null;
                    this.LastgangTool.getExportFile(lastgang.data || [], columnWidths ? { columnWidths } : null);
                }}
            />
        );
    }

    renderFunctionSelect(): JSX.Element[] {
        const elements: JSX.Element[] = [];
        const isEnergy: boolean = (this.units[this.state.curValue] || {}).isEnergy || false;

        Object.keys(this.functions).forEach((key: string, index: number) => {
            if (!this.state.functions[this.state.curValue]) {
                return;
            }
            elements.push(
                <label
                    style={{ marginLeft: index ? 10 : 5 }}
                    key={`label-function-${key}`}
                    htmlFor={`input-function-${key}`}
                >
                    {isEnergy && key === 'avg' ? 'sum.' : this.functions[key].name || null}
                </label>
            );
            elements.push(
                <input
                    key={`input-function-${key}`}
                    id={`input-function-${key}`}
                    type='checkbox'
                    checked={this.state.functions[this.state.curValue][key]}
                    disabled={
                        this.state.interval === 'all'
                        || (Object.values(this.state.functions[this.state.curValue]).filter((value: boolean) => value).length === 1
                            && this.state.functions[this.state.curValue][key]
                        )
                    }
                    onChange={(event: any) => this.onChangeFunction(event, key)}
                />
            );
        });

        return elements;
    }

    renderHeader(data: string, style?: React.CSSProperties): JSX.Element {
        return (
            <div
                style={{
                    fontSize: 12, fontWeight: 'bold', textAlign: 'center', backgroundColor: '#ddd', margin: 0, marginBottom: 15, padding: 3,
                    boxSizing: 'border-box', ...(style || {})
                }}
            >
                {data || null}
            </div>
        );
    }

    renderHelpIcon(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ right: 36, position: 'absolute' }}
                styleProps={{ margin: 0 }}
                label='Lastgang - Darstellung'
                helpKey='dialog_lastgang_darstellung'
                type='theme_info'
                style='theme_small'
                customElement='Info'
                editBar
                useTheme
            />
        );
    }

    renderIntervalSelect(): JSX.Element {
        const interval: string = this.state.interval || null;
        const intervalDiagram: string = this.getIntervalDiagram() || null;
        const title: string = intervalDiagram !== interval ? 'Die Diagrammauflösung ist aufgrund der Datenmenge geringer!' : null;

        return <>
            <div style={{ backgroundColor: '#ddd', padding: 3 }}>
                Intervall
            </div>
            <div className={style.rowContainer} style={{ width: '100%' }}>
                <select
                    style={{ width: '100%', padding: 1 }}
                    value={this.state.interval}
                    // disabled={!(this.state.curDiagram || '').toString().startsWith('interval')}
                    onChange={this.onChangeInterval}
                    title={title}
                >
                    <option
                        key='interval-all'
                        value='all'
                        title={this.state.interval === 'all' ? title : null}
                    >
                        maximal
                        {this.state.interval === 'all' && title && '*'}
                    </option>
                    {Object.keys(this.intervals).filter((name: string) => name !== '1#y').map((key: string) =>
                        <option
                            key={`interval-${key}`}
                            value={key}
                            title={this.state.interval === key ? title : null}
                        >
                            {this.intervals[key].name || null}
                            {this.state.interval === key && title && '*'}
                        </option>
                    )}
                </select>
                <select
                    style={{ width: '100%', padding: 1 }}
                    value={this.state.intervalFilter}
                    // disabled={['hoechstleistung', 'lastbereiche'].indexOf(this.state.curDiagram) !== -1}
                    onChange={this.onChangeIntervalFilter}
                >
                    {Object.keys(this.intervalFilters).map((key: string) =>
                        <option key={`interval-filter-${key}`} value={key}>
                            {this.intervalFilters[key].name || null}
                        </option>
                    )}
                </select>
            </div>
        </>;
    }

    renderJahresdaten(): JSX.Element {
        const spacer: number = 18;
        const width: number = this.widthChart ? this.widthChart - (2 * this.widthList) - (2 * spacer) : null;
        const styleWrapper: React.CSSProperties = { fontSize: 12, ...(width ? { minWidth: width, maxWidth: width } : {}), height: 229 };
        const isVisible: boolean = Object.keys(this.columns || {})
            .some((key: string) => this.columns[key].isEnergy || this.columns[key].isPower);

        return (
            <div className={style.rowContainer} style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
                <div style={{ width: this.widthList, margin: `0 ${spacer}px` }}>
                    {this.renderHeader('Jahreswerte')}
                    {this.state.dataDiagram &&
                        <div style={{ marginTop: -2 }}>
                            <LastgangJahreswerte data={this.state.dataDiagram} />
                        </div>
                    }
                </div>
                <div>
                    {this.renderHeader('Geordnete Jahresdauerlinie')}
                    <div style={styleWrapper}>
                        {this.state.dataDiagram &&
                            <LastgangDiagramme
                                key='lastbereiche'
                                containerSize={width ? { width } : null}
                                data={this.state.dataDiagram}
                                id='lastbereiche'
                                isLoaded={() => window.setTimeout(() => this.setAsyncItems(), 1)}
                                isStatic
                            />
                        }
                    </div>
                    {this.renderHeader('Tag mit der höchsten Leistung', { marginTop: 10 })}
                    <div style={{ ...styleWrapper, marginTop: 5 }}>
                        {this.state.dataDiagram &&
                            <LastgangDiagramme
                                key='hoechstleistung'
                                containerSize={width ? { width } : null}
                                data={this.state.dataDiagram}
                                id='hoechstleistung'
                                isLoaded={() => window.setTimeout(() => this.setAsyncItems(), 1)}
                                isStatic
                            />
                        }
                    </div>
                </div>
            </div>
        );
    }

    renderList(): JSX.Element {
        const data: any[] = this.dataTable || [];
        const cnt_show: number = data.length;
        const cnt_total: number = (this.data || []).length;
        const gapFunctions: number = this.state.interval === 'all' ? 27 : 0;
        // const start: number = +new Date();
        // console.log('render-time: ', (+new Date() - start) / 1000);
        return (
            <div style={{ textAlign: 'center', width: this.widthList }}>
                {this.renderHeader('Anpassung Haupttabelle')}
                <div
                    style={{
                        fontSize: 11, backgroundColor: '#ddd', padding: 3, border: '1px solid lightgray', display: 'flex',
                        flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly'
                    }}
                >
                    Es werden {cnt_show} von {cnt_total} Datensätzen angezeigt
                    {this.renderListPageSelect()}
                </div>
                {this.state.interval !== 'all' &&
                    <div
                        style={{
                            fontSize: 11, backgroundColor: '#ddd', padding: 3, border: '1px solid lightgray', display: 'flex',
                            flexDirection: 'row', alignItems: 'center'
                        }}
                    >
                        {this.renderFunctionSelect()}
                    </div>
                }
                <div
                    className={classNames(style.colContainer, style.tupelList)}
                    style={{ fontSize: 10, backgroundColor: '#ddd', marginRight: this.state.offsetScrollbar, display: 'flex' }}
                >
                    <div className={classNames(style.flexItem, style.rowContainer, style.tupelRow, style2.listHeader)}>
                        {this.renderListHeader()}
                    </div>
                </div>
                <div style={{ maxHeight: 434 + gapFunctions, overflow: 'auto', fontSize: 10 }} ref={this.refList}>
                    {this.renderListRows(data)}
                </div>
            </div>
        );
    }

    renderListHeader(): JSX.Element[] {
        const elements: any[] = [{ key: 'stamp', name: this.getIntervalDateHeader() }];
        const order: string = this.state.sortOrderDesc ? 'orderDesc' : 'orderAsc';

        Object.keys(this.columns).forEach((key: string) => {
            Object.keys(this.state.functions[key] || {}).forEach((key2: string) => {
                if (this.state.functions[key][key2]) {
                    elements.push(key2 === 'avg'
                        ? { key, name: this.columns[key].name || null }
                        : { key: `${key}-${key2}`, name: `${this.columns[key].name || ''} ${this.functions[key2].name || ''}` }
                    );
                }
            });
        });

        return elements.map((column: any, index: number) => {
            const classOrder: string = this.state.sortColumn === column.key ? style2[order] : style2.orderNone;
            return (
                <div
                    key={`header-${index}`}
                    className={classNames(style.flexItem, classOrder)}
                    onClick={() => classOrder && this.setOrderBy(column.key)}
                >
                    {column.name || null}
                </div>
            );
        });
    }

    renderListPageSelect(): JSX.Element {
        const options: JSX.Element[] = (this.pages || []).map((page: any, index) =>
            <option key={`page-${index}`} value={index}>
                {page.value || ''}
            </option>
        );

        return (
            <select
                value={this.state.curListPageIndex}
                disabled={options.length === 1}
                onChange={this.onChangeListPage}
            >
                {options}
            </select>
        );
    }

    renderListRows(data: any[]): JSX.Element {
        const pageLimit: number[] = ((this.pages || [])[this.state.curListPageIndex] || {}).limit
            || [0, (this.dataFiltered.length || 0) - 1];
        const sortColumn: string = this.state.sortColumn || 'stamp';
        const sortOrderDesc: boolean = this.state.sortOrderDesc || false;
        const tupel = (data || []).slice(pageLimit[0], pageLimit[1] + 1);
        const tupelFormatted: any[] = [...tupel]
            .sort((a: any, b: any) => (+a[sortColumn] || 0) < (+b[sortColumn] || 0)
                ? (sortOrderDesc ? 1 : -1) : (sortOrderDesc ? -1 : 1)
            )
            .map((i: any) => {
                const values: any = {};

                Object.keys(this.columns).forEach((key: string) => {
                    Object.keys(this.state.functions[key] || {}).forEach((key2: string) => {
                        if (this.state.functions[key][key2]) {
                            if (key2 === 'avg') {
                                values[key] = formatNumber(i[key]);
                            } else {
                                values[`${key}-${key2}`] = formatNumber(i[`${key}-${key2}`]);
                            }
                        }
                    });
                });
                return { keyX: i.keyX, ...values };
            });

        return <WSimpleNTupelList data={tupelFormatted} />;
    }

    renderPdfButton(): JSX.Element {
        const diagramOptions: number = (this.state.diagramOptions || []).length;
        const disabled: boolean = !diagramOptions || this.state.showSpinner;
        const styleProps: React.CSSProperties = disabled ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {};
        const tooltip: string = !diagramOptions
            ? 'Es wurde keine Einheit für Leistung bzw. Verbrauch in der Konfiguration angegeben!'
            : null;

        return (
            <WActionButton
                label='PDF generieren'
                insideText='PDF generieren'
                key='pdf'
                action='pdf'
                disabled={disabled}
                divStyle={{ fontSize: 12, textAlign: 'left', whiteSpace: 'nowrap' }}
                styleProps={styleProps}
                tooltip={tooltip}
                onAction={() => this.setState(
                    { showSpinner: true },
                    () => window.setTimeout(() => this.setPdfData(), 1)
                )}
            />
        );
    }

    renderResetButton(): JSX.Element {
        const styleProps: React.CSSProperties = this.state.showSpinner ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {};

        return (
            <WActionButton
                label='Einstellungen zurücksetzen'
                insideText='Einstellungen zurücksetzen'
                key='cancel'
                action='resetFilter'
                divStyle={{ fontSize: 12, textAlign: 'left', whiteSpace: 'nowrap' }}
                styleProps={styleProps}
                onAction={this.onResetSettings}
            />
        );
    }

    setAsyncItems(): void {
        const asyncItems: number = typeof this.state.asyncItems === 'number' && this.state.asyncItems > 0
            ? this.state.asyncItems - 1 : 0;
        this.setState<never>({ asyncItems, ...(!asyncItems ? { showSpinner: false } : {}) });
    }

    setData(): void {
        const areaFilterDay: number = ((this.state.areaFilters || {}).day || {}).value || null;
        const areaFilterDays: any[] = ((this.state.areaFilters || {}).day || {}).options || [];
        const dateFormat: string = this.getIntervalDateFormat();
        const interval: string = this.state.interval || null;
        const intervalDiagram: string = this.getIntervalDiagram() || null;
        const intervalFilter: any = (this.intervalFilters[this.state.intervalFilter] || {}).filter || {};
        const isArea: boolean = this.state.isArea || null;
        const lastgangData: any = this.state.lastgangData || {};
        const dataDiagram = lastgangData[intervalDiagram] || lastgangData.all || [];
        const pageFilter: string = !this.state.isArea ? (this.pageFilters[interval] || {}).interval || null : intervalFilter;
        const pageInterval: string = (pageFilter || '').toString().split('#')[1] || null;
        const pagePrefix: string = !this.state.isArea
            ? (this.pageFilters[interval] || {}).prefix || null
            : (this.intervals[interval] || {}).prefix || null;
        const pageTimestamps: number[] = [];
        const timestampAreaFrom: number = areaFilterDay || (areaFilterDays[0] || {}).value || null;
        let timestampAreaTo: number = areaFilterDay || (areaFilterDays[areaFilterDays.length - 1] || {}).value || null;
        timestampAreaTo = timestampAreaTo ? +Moment.unix(timestampAreaTo / 1000).hour(23).minute(59).second(59) : timestampAreaTo;
        const stampFrom = isArea ? timestampAreaFrom : this.state.stampFrom;
        const stampTo = isArea ? timestampAreaTo : this.state.stampTo;
        const viewInterval: string = (intervalDiagram || '').toString().split('#')[1] || null;
        const weekdays: number[] = Array.isArray(intervalFilter.weekdays) ? intervalFilter.weekdays : [];
        this.dataView = [];
        this.pages = [];

        if (pageFilter) {
            (lastgangData[pageFilter] || []).forEach((item: any) => pageTimestamps.push(item.stamp));
        }
        this.data = lastgangData[interval] || lastgangData.all || [];
        this.dataFiltered = this.data.filter((item: any) =>
            item.stamp >= stampFrom && item.stamp <= stampTo
            && (interval === 'all'
                ? (weekdays.length ? weekdays.indexOf(Moment.unix(+item.stamp / 1000).isoWeekday()) !== -1 : true)
                : true
            )
        );
        const lastIndex: number = this.dataFiltered.length - 1;
        this.dataTable = this.dataFiltered.map((item: any, index: number) => {
            const values: any = {};
            const getDate = (): string => {
                return +item.stamp > 0
                    ? (this.state.interval.split('#')[1] === 'w'
                        ? Moment(item.datetime).isoWeekday(1).format(dateFormat)
                        : Moment(item.datetime).format(dateFormat))
                    : null
            };

            Object.keys(this.columns).forEach((key: string) => {
                Object.keys(this.state.functions[key] || {}).forEach((key2: string) => {
                    if (this.state.functions[key][key2]) {
                        if (key2 === 'avg') {
                            values[key] = typeof item[key] !== 'undefined' ? item[key] : null;
                        } else {
                            values[`${key}-${key2}`] = interval === 'all'
                                ? typeof item[key] !== 'undefined' ? item[key] : null
                                : typeof item[`${key}-${key2}`] !== 'undefined' ? item[`${key}-${key2}`] : null;
                        }
                    }
                });
            });

            if ((pageFilter && (pageTimestamps.indexOf(item.stamp) !== -1 || !index)) || (!pageFilter && !(index % this.matchLimit))) {
                this.pages.push({
                    limit: [index, null],
                    value: pageInterval
                        ? (pageInterval === 'w'
                            ? `${pagePrefix || ''}${Moment(item.datetime).isoWeekday(1).format(this.getIntervalDateFormat(pageInterval))}`
                            : `${pagePrefix || ''}${Moment(item.datetime).format(this.getIntervalDateFormat(pageInterval))}`)
                        : Moment(item.datetime).format(dateFormat)
                });

                if (index) {
                    const endIndex: number = index === lastIndex ? lastIndex : index - 1;
                    const prevPage: any = this.pages[this.pages.length - 2];
                    prevPage.limit = [prevPage.limit[0], endIndex];
                    prevPage.value += !pageInterval ? ` - ${Moment(this.dataFiltered[endIndex].datetime).format(dateFormat)}` : '';
                }
            } else if (index === lastIndex) {
                const lastPage: any = this.pages[this.pages.length - 1];
                lastPage.limit = [lastPage.limit[0], index];
                lastPage.value += !pageInterval ? ` - ${Moment(this.dataFiltered[index].datetime).format(dateFormat)}` : '';
            }
            return { keyX: getDate(), stamp: item.stamp, ...values };
        });

        if (intervalDiagram !== interval) {
            dataDiagram.forEach((item: any) => {
                if (!(item.stamp >= stampFrom && item.stamp <= stampTo)) {
                    return;
                }
                const values: any = {};
                const getDate = (): string => {
                    return +item.stamp > 0
                        ? (intervalDiagram.split('#')[1] === 'w'
                            ? Moment(item.datetime).isoWeekday(1).format(this.getIntervalDateFormat(viewInterval))
                            : Moment(item.datetime).format(this.getIntervalDateFormat(viewInterval)))
                        : null
                };

                Object.keys(this.columns).forEach((key: string) => {
                    Object.keys(this.state.functions[key] || {}).forEach((key2: string) => {
                        if (this.state.functions[key][key2]) {
                            if (key2 === 'avg') {
                                values[key] = typeof item[key] !== 'undefined' ? item[key] : null;
                            } else {
                                values[`${key}-${key2}`] = intervalDiagram === 'all'
                                    ? typeof item[key] !== 'undefined' ? item[key] : null
                                    : typeof item[`${key}-${key2}`] !== 'undefined' ? item[`${key}-${key2}`] : null;
                            }
                        }
                    });
                });
                this.dataView.push({ keyX: getDate(), stamp: item.stamp, ...values });
            });
        } else {
            this.dataView = this.dataTable;
        }

        if (!this.pages.length) {
            this.pages.push({ limit: [null, null], value: 'zu wenige Daten' });
        }
    }

    setDiagramData(): void {
        const data: any = this.LastgangTool.getIntervalData() || {};
        const len: number = (data.all || []).length;
        const timestampFrom: number = +this.LastgangTool.getDateMin() || null;
        const year: number = timestampFrom ? Moment.unix(timestampFrom / 1000).year() : null;
        let timestampTo: number = null;

        for (let i: number = len - 1; !!i; --i) {
            if (+Moment((data.all[i] || {}).datetime || null).year() === year) {
                timestampTo = +data.all[i].datetime;
                break;
            }
        }
        this.setState({
            curDiagram: 'interval',
            dataDiagram: {
                columns: this.columns,
                data,
                energyUnits: this.LastgangTool.getEnergyUnits() || {},
                interval: this.LastgangTool.getInterval() || null,
                lineColors: this.colors || [],
                powerUnits: this.LastgangTool.getPowerUnits() || {},
                timestampFrom,
                timestampTo,
                units: this.units
            }
        });
    }

    setDiagramOptions(data: any): void {
        this.setState({ diagramOptions: (data || {}).options || [] });
    }

    setOrderBy(name: string): void {
        const sortOrderDesc: boolean = name === this.state.sortColumn ? !this.state.sortOrderDesc : false;
        this.setState(
            { showSpinner: true },
            () => window.setTimeout(() => this.setState({ showSpinner: false, sortColumn: name, sortOrderDesc }))
        );
    }

    setPdfData(): void {
        const data: any = this.LastgangTool.getIntervalData() || {};
        const len: number = (data.all || []).length;
        const timestampFrom: number = +this.LastgangTool.getDateMin() || null;
        const year: number = timestampFrom ? Moment.unix(timestampFrom / 1000).year() : null;
        let timestampTo: number = null;

        for (let i: number = len - 1; !!i; --i) {
            if (+Moment((data.all[i] || {}).datetime || null).year() === year) {
                timestampTo = +data.all[i].datetime;
                break;
            }
        }
        this.setState({
            dataPdf: {
                columns: this.columns,
                data,
                energyUnits: this.LastgangTool.getEnergyUnits() || {},
                interval: this.LastgangTool.getInterval() || null,
                powerUnits: this.LastgangTool.getPowerUnits() || {},
                timestampFrom,
                timestampTo,
                units: this.units
            }
        });
    }

    private onDataLoaded(dataLoaded: string): void {
        this.tsLoaded = +new Date();
        this.LastgangTool = new LastgangProcess(dataLoaded || null, this.props.lastgangSelected.konfiguration || null);
        this.LastgangTool.setIntervals(this.intervals);
        const areaFilters: any = {};
        const functions: any = {};
        const stampMin: number = +this.LastgangTool.getDateMin() || null;
        const stampMax: number = +this.LastgangTool.getDateMax() || null;
        const units: any[] = this.LastgangTool.getUnits() || [];
        const init = () => {
            this.setData(); this.setState(
                { areaFilters: this.getAreaFilter() || {}, ...(!!this.state.asyncItems && { showSpinner: true }) },
                () => window.setTimeout(() => this.setDiagramData(), 1)
            )
        };
        let hasUnits: boolean = false;

        (this.LastgangTool.getColumns() || []).forEach((column: any, index: number) => {
            column = column || {};
            const isPower: boolean = column.isPower || false;
            const key: string = column.key || null;
            hasUnits = (column.isEnergy || column.isPower) ? true : hasUnits;
            functions[key] = {};
            this.columns[key] = column || null;
            this.units[key] = units[index] || null;

            Object.keys(this.functions).forEach((key2: string) => {
                functions[key][key2] = key2 === (isPower ? 'max' : 'avg');
            });
        });

        Object.keys(this.areas).forEach((key2: string) => {
            areaFilters[key2] = { options: [] };
        });
        this.setState<never>(
            {
                isLoaded: true,
                showSpinner: false,
                dataLoaded,
                lastgangData: this.LastgangTool.getIntervalData((this.intervalFilters[this.state.intervalFilter] || {}).filter || null),
                areaFilters,
                functions,
                stampMin,
                stampMax,
                stampFrom: stampMin,
                stampTo: stampMax,
                ...(!hasUnits && { asyncItems: 0 })
            },
            () => Object.keys(this.columns || {}).length ? init() : null
        );
    }
}
